import * as React from 'react';
import LeaseGenerationOwnerData from 'src/models/leasing/LeaseGenerationOwnerData';
import Form from 'src/components/controls/forms/Form';
import FormTextBox from 'src/components/controls/forms/redesign/FormTextbox';
import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
import PropertyUtil from 'src/util/PropertyUtil';
import PagedResultSet from 'src/models/common/PagedResultSet';
import State from 'src/models/State';
import IOwner from 'src/models/IOwner';
import { SelectItem } from 'src/models/common/SelectItem';
import { AnyObject } from 'react-final-form';
import * as _ from 'lodash';
import Button from 'src/components/controls/forms/redesign/FormButton';
import OwnerBOLM from 'src/models/tract_detail/add_ownership_revised/OwnerBOLM';
import { FormApi } from 'final-form';
import MultiplePhoneNumber from '../TractComponents/MultiplePhoneNumber';
import PhoneNumberType from 'src/models/PhoneNumberType';
import Prefixes from 'src/models/Prefixes';
import Suffixes from 'src/models/Suffixes';
import FormCheckbox from 'src/components/controls/forms/redesign/FormCheckbox';

interface IBOLMOwnerFormProps {
    handleOnSubmit: (formValues: IOwner) => void;
    ownerData: LeaseGenerationOwnerData;
    states: PagedResultSet<State>;
    phoneNumberTypes: Array<PhoneNumberType>;
}

class BOLMOwnerForm extends React.Component<IBOLMOwnerFormProps> {
    private form: FormApi;
    componentDidMount() {
        this.form.reset();
    }
    validateForm = (values: AnyObject) => {
        const errors: AnyObject = {};
        if (!_.get(values, 'bolmOwner.regionalOffice')) {
            _.set(errors, 'bolmOwner.regionalOffice', 'Required');
        }
        if (!_.get(values, 'bolmOwner.contactPersonFirstName')) {
            _.set(errors, 'bolmOwner.contactPersonFirstName', 'Required');
        }
        if (!_.get(values, 'bolmOwner.contactPersonLastName')) {
            _.set(errors, 'bolmOwner.contactPersonLastName', 'Required');
        }
        return errors;
    };

    parseOwnerDetailFormValues = (formValues: AnyObject) => {
        const updatedOwnerDetail = new OwnerBOLM(formValues.bolmOwner);
        this.props.handleOnSubmit(updatedOwnerDetail);
    };

    public render() {
        const states = PropertyUtil.SafeGet(() => this.props.states.items);
        const selectStates = states ? states.map((state: State) => new SelectItem(state.id, state.name)) : new Array<SelectItem>();
        const bolmOwner = this.props.ownerData.ownerDetails as OwnerBOLM;

        return (
            <div>
                <h2 style={{marginLeft: '3rem'}}>Bureau of Land Management Owner Form</h2>
                <Form
                    onSubmit={this.parseOwnerDetailFormValues}
                    style={{padding: '3rem'}}
                    initialValues={{ bolmOwner: bolmOwner }}
                    validate={this.validateForm}
                    onFormCreated={(form) => {
                        this.form = form;
                    }}
                    hasFieldArray={true}
                >
                    <div>
                        <FormTextBox 
                            name="bolmOwner.regionalOffice" 
                            label="Regional Office" 
                            className="lh-half-width" 
                            isRequired={true} 
                            style={{width: '49.7%'}} 
                        />
                        <FormTextBox 
                            name="bolmOwner.ssnTaxId" 
                            label="Tax Id" 
                            className="lh-fourth-width"
                            style={{width: '24.8%'}} 
                        />
                        <FormSelect 
                            name="bolmOwner.stateId" 
                            label="State" 
                            items={selectStates} 
                            className="lh-fourth-width"
                            style={{marginLeft: '.5rem', width: '24.8%'}}  
                        />
                    </div>
                    <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0', marginBottom: '.2rem' }}>
                        <legend style={{ marginBottom: '1.25rem', marginLeft: '1rem' }}>Contact Person</legend>
                    </fieldset>
                    <div>
                        <FormTextBox    
                            name="bolmOwner.contactPersonFirstName" 
                            label="First Name" 
                            className="lh-third-width" 
                            isRequired={true} 
                        />
                        <FormTextBox 
                            name="bolmOwner.contactPersonMiddleName" 
                            label="Middle Name" 
                            className="lh-third-width" 
                        />
                        <FormTextBox 
                            name="bolmOwner.contactPersonLastName" 
                            label="Last Name" 
                            className="lh-third-width" 
                            isRequired={true} 
                            style={{marginLeft: '.5rem'}} 
                        />
                    </div>
                    <div>
                        <FormSelect 
                            name="bolmOwner.contactPersonPrefix" 
                            label="Prefix" 
                            items={Prefixes} 
                            className="lh-third-width" 
                        />
                        <FormSelect 
                            name="bolmOwner.contactPersonSuffix" 
                            label="Suffix" 
                            items={Suffixes} 
                            className="lh-third-width" 
                        />
                        <FormTextBox 
                            name="bolmOwner.email" 
                            label="Email" 
                            className="lh-third-width" 
                            style={{marginLeft: '.5rem'}} 
                        />
                    </div>
                    <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0', marginBottom: '.2rem' }}>
                        <legend style={{ marginBottom: '1.25rem', marginLeft: '1rem' }}>Address</legend>
                    </fieldset>
                    <div>
                        <FormTextBox 
                            name="bolmOwner.address.addressLine1" 
                            label="Address Line 1" 
                            className="lh-full-width" 
                        />
                        <FormTextBox 
                            name="bolmOwner.address.addressLine2" 
                            label="Address Line 2" 
                            className="lh-full-width" 
                        />
                    </div>
                    <div>
                        <FormTextBox 
                            name="bolmOwner.address.city" 
                            label="City" 
                            className="lh-third-width" 
                        />
                        <FormSelect 
                            name="bolmOwner.address.stateId" 
                            label="State" 
                            items={selectStates} 
                            className="lh-third-width" 
                        />
                        <FormTextBox 
                            name="bolmOwner.address.zipCode" 
                            label="Zip Code" 
                            className="lh-third-width" 
                            style={{marginLeft: '.5rem'}} 
                        />
                    </div>
                    <div>
                        <FormCheckbox 
                            name="bolmOwner.isClientAcreage" 
                            label="This is the Client" 
                        />
                    </div>
                    <div style={{marginLeft: '.5rem'}}>
                        <MultiplePhoneNumber 
                            baseFieldName="bolmOwner" 
                            form={this.form} 
                            phoneNumberTypes={this.props.phoneNumberTypes} 
                        />
                    </div>
                    <div className="button-row">
                        <Button 
                            text="Save" 
                            type="submit" 
                            intent="primary"
                            style={{marginLeft: '.5rem'}} 
                        />
                    </div>
                </Form>
            </div>
        );
    }
}

export default BOLMOwnerForm;



// WEBPACK FOOTER //
// ./src/components/project/sections/owners/BOLMOwnerForm.tsx